var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.586,
    height: 11.054,
    viewBox: "0 0 13.586 11.054",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u041C\\u0435\\u0442\\u0440\\u043E",
    transform: "translate(0 -8.732)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1663",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1663",
    d: "M11.21,8.732,6.869,14.9,2.435,8.875,0,18.956H3.3l.6-3.224,2.917,4.054,2.9-3.965.584,3.153h3.285Z",
    transform: "translate(0 0)",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetro);
export default __webpack_public_path__ + "static/media/Metro.ba98da6cc3e1af104a2879bcb82afac4.svg";
export { ForwardRef as ReactComponent };